export const getFormattedFileName = (fileName: string) => {
  if (fileName) {
    if (fileName.length < 10) return fileName;
    else return `${fileName.slice(0, 10)}...`;
  }
  return '';
};
